import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams, useNavigate, useLocation } from "react-router";
import { UserService } from '../../services/UserService';
import { FolderService } from '../../services/FolderService';
import ColManager from '../../components/table/dynamic-table/col-manager/ColManager';
import { GlobalContext, GlobalDispatchContext } from "../../services/GlobalProvider";
import axios from 'axios';
import { Table, Badge, InputGroup, Alert, FormControl, Container, Button, Dropdown, DropdownButton, Form, Col, Row, Spinner, OverlayTrigger, Tooltip, Modal, ToastContainer, Accordion } from 'react-bootstrap';
import lost from '../../assets/img/illustrations/lost.png'
import ErrorManager from "../../components/error-manager/ErrorManager";


export default function Error() {

    const [searchParams, setSearchParams] = useSearchParams();
    const { userDetails, folderDetails, parametres, folders, setFolderDetails, preferences, globalContextLoaded, globalContextErrorList } = React.useContext(GlobalContext);
    
    const errorParam = searchParams.get('error-id')

    return (

        <div className="position-relative h-100">
            <div className="position-absolute top-50 start-50 translate-middle d-flex align-items-center">

                <div>
                    {!errorParam &&
                        <>
                            <h1 className="text-primary">Page introuvable</h1>
                            <h6>La page à laquelle vous tentez d'accéder est introuvable.</h6>
                        </>
                    }
                    {errorParam == "folder-not-found" &&
                        <>
                            <h1 className="text-primary">Dossier introuvable</h1>
                            <h6>Le dossier auquel vous tentez d'accéder est introuvable.</h6>
                            <a href="/dossiers">Voir les dossiers disponibles</a>
                        </>
                    }
                    {errorParam == "folder-error" &&
                        <>
                            <h1 className="text-primary">Erreur</h1>
                            <h6>Erreur lors de la récupération des dossiers.</h6>
                        </>
                    }

                    {(globalContextErrorList?.length > 0) &&
                        <div className="mt-4 w-100">
                            {globalContextErrorList.map((error, i) => (
                                <ErrorManager key={i} error={error} />
                            ))}
                        </div>
                    }

                </div>
            </div>

        </div>

    );
}